<!--
 * @Author: your name
 * @Date: 2020-10-16 10:35:14
 * @LastEditTime: 2020-10-22 18:15:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zhulogic-design-cloud-next/src/views/workLocation/components/item.vue
-->
<template>
  <div v-if="items" class="work-item" @click="openWorkDetail(items.id)">
    <div class="top-title">
      <Row>
        <Col span="20">
          <div class="name">{{ items.expectPosition }}</div>
          <div class="des">
            {{ items.name }} / {{ items.sex == 1 ? '男' : '女' }} /
            {{ items.experienceDisplay }} /
            {{ items.educationDisplay }}
          </div>
        </Col>
        <Col span="4" style="text-align:right">
          <img
            v-if="!items.avatarFile"
            class="factory-img"
            src="https://oss.zhulogic.com/planImage/fa/877_dir/5WKBaPrpdAWtkHiEjjS4HjyGrKzdXPfh75.png"
            alt=""
          />
          <img
            v-else
            class="factory-img"
            :src="ossPrefix + items.avatarFile.keyTwo"
            alt=""
          />
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    items: {
      default: null,
      type: [Object, String],
    },
  },
  data() {
    return {}
  },
  methods: {
    openWorkDetail(id) {
      this.$router.push({
        path: '/worker-detail-small?id=' + id,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.work-item {
  width: 100%;
  height: 85px;
  padding: 20px;
  background: #ffffff;
  cursor: pointer;
  .top-title {
    padding-bottom: 12px;
    .name {
      font-size: 16px;
      font-weight: 500;
      color: #373737;

      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }
    .des {
      font-size: 14px;
      font-weight: 500;
      color: #999999;
      margin-top: 5px;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }
    .factory-img {
      display: inline-block;
      width: 45px;
      height: 45px;
      object-fit: cover;
    }
  }
}
</style>
